import { Pipe, PipeTransform } from '@angular/core';
import { NavItem } from './header-nav.model';

@Pipe({
  name: 'filterOffers',
  standalone: true
})
export class FilterOffersPipe implements PipeTransform {
  transform(navItems: NavItem[]): NavItem[] {
    if (!navItems) {
      return [];
    }
    return navItems.filter(item => item.type !== 'offers');
  }
}
